<nb-card class="no-edge-card mb-0 modal-height-100-62">
	<!-- Boton de Cerrar -->
	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal('')"
			nbTooltip="{{ 'SIGMACOMPONENT.CERRAR' | translate }}" nbTooltipPlacement="left">
		</nb-icon>
	</div>
	<!-- FIN Boton de Cerrar -->

	<!-- PANTALLA DE CARGA -->
	<div *ngIf="loading" class="informe-loading-overlay">
		<div class="informe-loading-content">
			<h4 class="informe-loading-title">{{ 'LOADERS.TITLE_REPORTING' | translate }}</h4>
			<div class="loaderBar mt-3 mb-3"></div>
			<p class="informe-loading-message">{{ mensajeActual }}</p>
			<button nbButton size="small" status="basic" appearance="outline" class="mt-3" (click)="cancelarLoading()">
				<nb-icon icon="close-outline"></nb-icon>
				{{ 'GLOBALS.CANCEL' | translate }}
			</button>
		</div>
	</div>
	<!-- FIN PANTALLA DE CARGA -->

	<nb-card-header *ngIf="expandedUserIndex === -1" class="informe-header">
		<div class="d-flex align-items-center">
			<!--===== version desktop =====-->
			<div *ngIf="!isMobile" class="d-flex justify-content-between w-100 align-items-center pr-5">
				<!-- Filtros -->
				<div class="d-flex flex-column gap-2">
					<span class="text-hint caption-2 text-uppercase informe-header-label">
						Tipo de consulta
					</span>
					<!-- Botones consultas -->
					<div class="d-flex gap-2 flex-wrap">
						<button *ngFor="let consulta of filteredConsultas" nbButton size="small" shape="semi-round"
							[status]="consultaID === consulta.id ? 'primary' : 'basic'"
							[appearance]="consultaID === consulta.id ? 'filled' : 'outline'"
							(click)="consultaID = consulta.id; onConsultaChange()">
							{{ consulta.title }}
						</button>
					</div>
				</div>
				<div class="d-flex align-items-center gap-3" *ngIf="step === 3 && expandedUserIndex === -1">
					<!-- Inicio Buscador -->
					<div class="informe-search-wrapper" [formGroup]="formulario">
						<nb-form-field>
							<nb-icon nbPrefix icon="search-outline"></nb-icon>
							<input type="text" nbInput fullWidth placeholder="Buscar..." formControlName="userFilter"
								fieldSize="small" shape="round">
							<button nbSuffix nbButton ghost size="tiny" (click)="clearUserFilter()"
								*ngIf="formulario.get('userFilter')?.value">
								<nb-icon icon="close-outline"></nb-icon>
							</button>
						</nb-form-field>
					</div>
					<!-- Fin Buscador -->
					<!-- Divider -->
					<div class="informe-header-divider"></div>
					<!-- Inicio Botones para Ordenar -->
					<div class="d-flex gap-2 align-items-center">
						<span class="text-hint caption-2 text-nowrap">Ordenar por:</span>
						<nb-button-group size="small" status="primary">
							<button nbButtonToggle [pressed]="sortCriteria === 'time'" (click)="setSort('time')">Tiempo
								Total</button>
							<button *ngIf="role === 3 || role === 0" nbButtonToggle
								[pressed]="sortCriteria === 'challenges'"
								(click)="setSort('challenges')">Desafíos</button>
							<button *ngIf="role === 1" nbButtonToggle [pressed]="sortCriteria === 'projects'"
								(click)="setSort('projects')">Proyectos</button>
							<button *ngIf="role === 1" nbButtonToggle [pressed]="sortCriteria === 'ideographs'"
								(click)="setSort('ideographs')">Ideógrafos</button>
							<button *ngIf="role === 1" nbButtonToggle [pressed]="sortCriteria === 'ideas'"
								(click)="setSort('ideas')">Ideas</button>
							<button *ngIf="role === 1" nbButtonToggle [pressed]="sortCriteria === 'activities'"
								(click)="setSort('activities')">Actividades</button>
							<button *ngIf="role === 2" nbButtonToggle [pressed]="sortCriteria === 'timeActivities'"
								(click)="setSort('timeActivities')">Tiempo en Actividades</button>
							<button *ngIf="role === 2" nbButtonToggle [pressed]="sortCriteria === 'timeIdeas'"
								(click)="setSort('timeIdeas')">Tiempo en Ideas</button>
						</nb-button-group>
					</div>
					<!-- Fin Botones para Ordenar -->
				</div>
			</div>
		</div>
	</nb-card-header>
	<nb-card-body>
		<div class="row h-195">
			<!-- Inicio panel lateral (arbol) -->
			<div class="col-12 col-xl-3" *ngIf="expandedUserIndex === -1">
				<div class="d-flex flex-column informe-sidebar h-195 p-3 overflow-auto">
					<!-- Buscador del sidebar -->
					<div class="mb-3" [formGroup]="formulario">
						<nb-form-field>
							<nb-icon nbPrefix icon="search-outline"></nb-icon>
							<input type="text" nbInput fullWidth placeholder="Filtrar..." formControlName="filtrado"
								fieldSize="small" shape="round">
							<button nbSuffix nbButton ghost size="tiny" (click)="clearSearch()"
								*ngIf="formulario.get('filtrado')?.value">
								<nb-icon icon="close-outline"></nb-icon>
							</button>
						</nb-form-field>
					</div>
					<!--PRIMER NIVEL DEL ARBOL-->
					<ul *ngIf="allDatasets.length > 0" class="m-0 pt-0 pb-0 pl-0 pr-1 tree-list">
						<li *ngFor="let label_1 of allDatasets; let i = index">
							<div class="d-flex py-2 px-3 gap-2 tree-node pointer"
								[class.selected]="selectedLabel === label_1">
								<div (click)="viewChildren2(i)" class="tree-level-1">
									<nb-icon icon="chevron-right-outline" status="basic"
										*ngIf="!label_1.childrenVisible && label_1.children.length > 0">
									</nb-icon>
									<nb-icon icon="chevron-down-outline" status="basic"
										*ngIf="label_1.childrenVisible && label_1.children.length > 0">
									</nb-icon>
									<span> {{ label_1.label }} </span>
								</div>
								<div (click)="viewData(label_1.data, label_1, 1)">
									<nb-icon icon="eye-outline" status="basic"
										*ngIf="(selectedLabel === label_1) && (label_1.data != null && label_1.data.length > 0)">
									</nb-icon>
									<nb-icon icon="eye-off-2-outline" status="basic"
										*ngIf="(selectedLabel !== label_1) && (label_1.data != null && label_1.data.length > 0)">
									</nb-icon>
								</div>
							</div>
							<!--SEGUNDO NIVEL DEL ARBOL-->
							<ul *ngIf="label_1.children.length > 0" class="style-list"
								[ngStyle]="{'display': label_1.childrenVisible ? 'block' : 'none'}">
								<li *ngFor="let label_2 of label_1.children; let j = index">
									<div class="d-flex p-1 gap-2 tree-node pointer"
										[class.selected]="selectedLabel === label_2">
										<div (click)="viewChildren3(i, j)" class="tree-level-2">
											<nb-icon icon="chevron-right-outline" status="basic"
												*ngIf="!label_2.childrenVisible && label_2.children.length > 0">
											</nb-icon>
											<nb-icon icon="chevron-down-outline" status="basic"
												*ngIf="label_2.childrenVisible && label_2.children.length > 0">
											</nb-icon>
											<span> {{ label_2.label }} </span>
										</div>
										<div (click)="viewData(label_2.data, label_2, 2)">
											<nb-icon icon="eye-outline" status="basic"
												*ngIf="(selectedLabel === label_2) && (label_2.data != null && label_2.data.length > 0)">
											</nb-icon>
											<nb-icon icon="eye-off-2-outline" status="basic"
												*ngIf="(selectedLabel !== label_2) && (label_2.data != null && label_2.data.length > 0)">
											</nb-icon>
										</div>
									</div>
									<!--TERCER NIVEL DEL ARBOL-->
									<ul *ngIf="label_2.children.length > 0" class="style-list"
										[ngStyle]="{'display': label_2.childrenVisible ? 'block' : 'none'}">
										<li *ngFor="let label_3 of label_2.children">
											<div class="d-flex py-1 px-3 gap-2 tree-node tree-level-3 pointer"
												[class.selected]="selectedLabel === label_3"
												(click)="viewData(label_3.data, label_3, 3, label_2)">
												<div>
													{{ label_3.label }}
												</div>
												<div *ngIf="label_2.data[0]?.data[0] > 0">
													<nb-icon icon="eye-outline" status="basic"
														*ngIf="(selectedLabel === label_3) && (label_3.data != null && label_3.data.length > 0)">
													</nb-icon>
													<nb-icon icon="eye-off-2-outline" status="basic"
														*ngIf="(selectedLabel !== label_3) && (label_3.data != null && label_3.data.length > 0)">
													</nb-icon>
												</div>
											</div>
										</li>
									</ul>
								</li>
							</ul>
						</li>
					</ul>
				</div>
			</div>
			<!-- Fin panel lateral (arbol) -->

			<!-- Inicio panel graficos -->
			<div class="col-12 h-195" [class.overflow-auto]="expandedUserIndex === -1"
				[class.overflow-hidden]="expandedUserIndex !== -1" [class.col-xl-9]="expandedUserIndex === -1"
				*ngIf="datasetsImported || step === 3 || noDataMessage">

				<!-- Mensaje sin datos -->
				<div *ngIf="noDataMessage"
					class="informe-no-data w-100 h-100 d-flex flex-column justify-content-center align-items-center">
					<nb-icon icon="bar-chart-outline" class="informe-no-data-icon"></nb-icon>
					<h5 class="informe-no-data-title mt-3">No se registraron datos</h5>
					<p class="informe-no-data-text">No hay actividad registrada en el periodo seleccionado.</p>
				</div>

				<!-- LISTADO DE USUARIOS -->
				<div *ngIf="step === 3 && !noDataMessage" class="w-100 h-100 p-4">

					<div class="d-flex flex-wrap gap-3" [class.h-100]="expandedUserIndex !== -1">
						<!-- Inicio Tarjetas de Usuarios -->
						<nb-card *ngFor="let user of usersList; let i = index" class="informe-user-card"
							[class.informe-user-card--expanded]="expandedUserIndex === i"
							[class.informe-user-card--hidden]="expandedUserIndex !== -1 && expandedUserIndex !== i">
							<nb-card-body [class.d-flex]="expandedUserIndex === i"
								[class.flex-column]="expandedUserIndex === i" [class.h-100]="expandedUserIndex === i">
								<div [class.flex-shrink-0]="expandedUserIndex === i"
									[class.informe-user-card__header-border]="expandedUserIndex === i">
									<!-- Inicio Ver/Ocultar Detalles -->
									<div class="d-flex justify-content-between align-items-start">
										<nb-user [name]="role === 0 ? user.name : (user.name + ' ' + user.surname)"
											[title]="role === 0 ? user.surname : ''" size="medium"
											onlyPicture="false"></nb-user>
										<button nbButton ghost size="tiny" status="primary"
											(click)="toggleExpandedUser(i, user)">
											<nb-icon
												[icon]="expandedUserIndex === i ? 'arrow-back-outline' : 'expand-outline'"></nb-icon>
											{{ expandedUserIndex === i ? 'Ocultar' : 'Detalles' }}
										</button>
									</div>
									<!-- Fin Ver/Ocultar Detalles -->

									<!-- Inicio Datos estadisticos -->
									<div class="informe-user-stats mt-3" [class.row]="expandedUserIndex === i">
										<div [class.col-6]="expandedUserIndex === i">
											<div class="informe-stat-row mt-1">
												<span class="informe-stat-label">Tiempo Total:</span>
												<span class="informe-stat-value">{{
													formatTime(user.tiempoActivoTotal_ms) }}</span>
											</div>
											<div class="informe-stat-row" *ngIf="role == 1">
												<span class="informe-stat-label">Proyectos Creados:</span>
												<span class="informe-stat-value">{{ user.proyectosCreados || 0 }}</span>
											</div>
											<div class="informe-stat-row" *ngIf="role == 1">
												<span class="informe-stat-label">Ideografos Creados:</span>
												<span class="informe-stat-value">{{ user.grafosCreados || 0 }}</span>
											</div>
											<div class="informe-stat-row" *ngIf="role == 1">
												<span class="informe-stat-label">Ideas Creadas:</span>
												<span class="informe-stat-value">{{ user.ideasCreadas || 0 }}</span>
											</div>
											<div class="informe-stat-row" *ngIf="role == 1">
												<span class="informe-stat-label">Actividades Creadas:</span>
												<span class="informe-stat-value">{{ user.actividadesCreadas || 0
													}}</span>
											</div>
											<div class="informe-stat-row" *ngIf="role == 2">
												<span class="informe-stat-label">Tiempo en Ideas:</span>
												<span class="informe-stat-value">{{ formatTime(user.tiempoIdeas_ms)
													}}</span>
											</div>
											<div class="informe-stat-row" *ngIf="role == 2">
												<span class="informe-stat-label">Tiempo en Actividades:</span>
												<span class="informe-stat-value">{{
													formatTime(user.tiempoActividades_ms) }}</span>
											</div>
										</div>

										<div [class.col-6]="expandedUserIndex === i">
											<div class="informe-stat-row" *ngIf="role == 2">
												<span class="informe-stat-label">Actividades Realizadas:</span>
												<span class="informe-stat-value">{{ user.actividadesRealizadas || 0
													}}</span>
											</div>
											<div class="informe-stat-row" *ngIf="role == 3 || role == 2 || role == 0">
												<span class="informe-stat-label">Desafíos Realizados:</span>
												<span class="informe-stat-value">{{ user.desafiosRealizados || 0
													}}</span>
											</div>
										</div>
									</div>
								</div>
								<!-- Fin Datos estadisticos -->

								<!-- Contenedor de Graficas con Scroll -->
								<div *ngIf="expandedUserIndex === i" class="flex-grow-1 overflow-auto mt-3 px-2 pb-2">
									<!-- Grafica de tiempo activo -->
									<div class="informe-chart-container mt-3">
										<canvas id="chart-user-{{i}}"></canvas>
									</div>

									<!-- Grafica estudiante ideas/actividades -->
									<div *ngIf="role === 2" class="informe-chart-container mt-3">
										<canvas id="chart-user-2-{{i}}"></canvas>
									</div>

									<!-- Grafica editor creaciones -->
									<div *ngIf="role === 1" class="informe-chart-container mt-3">
										<canvas id="chart-user-1-{{i}}"></canvas>
									</div>
								</div>
							</nb-card-body>
						</nb-card>
						<!-- Fin Tarjetas de Usuarios -->
					</div>
					<div *ngIf="!usersList || usersList.length === 0" class="text-center mt-5">
						<label class="label">{{ 'TOTALHISTORYUSER.NODATATOSHOW' | translate }}</label>
					</div>
				</div>

				<!-- GRAFICA DE BARRAS SIMPLES -->
				<div id="barras" class="w-100 h-100 px-5" *ngIf="verBotonesGraficas == 1">
					<app-barras-admin [consultaID]="consultaID" [role]="role" [datasetsImported]="datasetsImported"
						[labelsImported]="labelsImported" (verDetalle)="verDetalle($event)">
					</app-barras-admin>
				</div>
				<!-- GRAFICA DE BARRAS AGRUPADAS -->
				<div id="barras_group" class="w-100 h-100 px-5" *ngIf="verBotonesGraficas == 2">
					<app-barras-group-admin [consultaID]="consultaID" [role]="role"
						[datasetsImported]="datasetsImported" [labelsImported]="labelsImported"
						(verDetalle)="verDetalle($event)">
					</app-barras-group-admin>
				</div>
			</div>
		</div>
	</nb-card-body>
</nb-card>